const axios = require('axios')

let cancelerMap = new Map()

class AxiosCancel {
    static createInstance () {
        return this.instance ? this.instance : (this.instance = new AxiosCancel())
    }
    add (config) {
        const url = config.url
        this.remove(url)
        config.cancelToken = new axios.CancelToken((cancel) => {
            if (!cancelerMap.has(url)) {
                cancelerMap.set(url, cancel)
            }
        })
    }
    remove (url) {
        if (cancelerMap.has(url)) {
            const cancel = cancelerMap.get(url)
            cancel && cancel(url)
            cancelerMap.delete(url)
        }
    }
}

const axiosCancel = AxiosCancel.createInstance()
// module.exports = axiosCancel
export default axiosCancel



// WEBPACK FOOTER //
// ./src/utils/request/cancel.js